export default __webpack_public_path__ + "static/usa-news-banner-f332e9e45f86b3ebbbfc32322d170c83.svg";